import { ApiException } from '@eta/components';
import {
    LOAD_TAXPAYER_PROFILE,
    TaxpayerProfileActionTypes,
    UPDATE_TAXPAYER_PROFILE,
    LOAD_TAXPAYER_NOTIFICATIONS,
    UPDATE_TAXPAYER_NOTIFICATIONS,
    INVITE_USER,
    ADDERP_SYSTEM,
    EDIT_ERPSYSTEM,
    BLOCK_USER
} from './Types';
import {
    GetCurrentTaxpayerResponseDto,
    RegisterDelegateResponseDto,
} from '../../Services/ClientProxy/clientProxy';
import { GetUserPreferenceResponse } from '../../Services/ClientProxy/NotificationManagementClient';

export interface TaxpayerProfileState {
    currentTaxpayerProfile?: GetCurrentTaxpayerResponseDto;
    currentNotifications?: GetUserPreferenceResponse;
    addErpSystem?: RegisterDelegateResponseDto;
    lastError?: ApiException;
}

const initialState: TaxpayerProfileState = {};

export function taxpayerReducer(
    state = initialState,
    action: TaxpayerProfileActionTypes
) {
    switch (action.type) {
        case LOAD_TAXPAYER_PROFILE:
            return {
                ...state,
                currentTaxpayerProfile: { ...action.payload },
            };
        case LOAD_TAXPAYER_NOTIFICATIONS:

            return {
                ...state,
                currentNotifications: { ...action.payload },
            };
        case UPDATE_TAXPAYER_PROFILE:
            return {
                ...state,
                ...action.payload,
            };
        case UPDATE_TAXPAYER_NOTIFICATIONS:
            return {
                ...state,
                ...action.payload,
            };
        case INVITE_USER:
            return {
                ...state,
                ...action.payload,
            };
        case ADDERP_SYSTEM:
            return {
                ...state,
                ...action.payload,
            };
        case EDIT_ERPSYSTEM:
            return {
                ...state,
                ...action.payload,
            };
        case BLOCK_USER:
            return {
                ...state,
                ...action.payload,
            };
        default:
            return state;
    }
}
